import queryString from "query-string";

import goToUrl from "shared/util/goToUrl";
import { APPS as LIKES_APPS } from "apps/userrows/util/constants";

// if there is a cf url param, send the user back to the page from
// which they came
export default function redirectToWhereTheyCameFrom(history) {
	const cf = queryString.parse(window.location.search).cf;

	if (!cf) {
		goToUrl("/home", history);
		return;
	}

	if (cf.includes("boost")) {
		goToUrl("/boost", history);
	} else if (cf.includes("messages")) {
		goToUrl("/messages", history);
	} else if (cf.includes("upgrade")) {
		goToUrl("/upgrade", history);
	} else if (cf.includes("settings")) {
		goToUrl("/settings", history);
	} else if (cf.includes("profile")) {
		goToUrl("/profile", history);
	} else if (cf.includes("doubletake")) {
		goToUrl("/doubletake", history);
	} else if (cf.includes("discovery")) {
		goToUrl("/discovery", history);
	} else if (cf.includes("matchsearch")) {
		goToUrl("/match", history);
	} else if (cf.includes(LIKES_APPS.likesIncoming)) {
		goToUrl("/who-likes-you", history);
	} else if (cf.includes(LIKES_APPS.likesOutgoing)) {
		goToUrl("/who-you-like", history);
	} else if (cf.includes(LIKES_APPS.intros)) {
		goToUrl("/intros", history);
	} else {
		goToUrl("/home", history);
	}
}



// WEBPACK FOOTER //
// ./src/shared/util/redirectToWhereTheyCameFrom.js